module.exports = __webpack_public_path__ + "img/fruits.f8abb166.jpg";